import React from 'react';

/**
 * PositionLedgerSummary - Display aggregate P&L and position counts
 */
function PositionLedgerSummary({ summary }) {
  const totalPnL = parseFloat(summary.total_pnl_num || 0);
  const stockPnL = parseFloat(summary.stock_pnl_num || 0);
  const optionPnL = parseFloat(summary.option_pnl_num || 0);

  const pnlClass = totalPnL >= 0 ? 'text-success' : 'text-danger';
  const stockClass = stockPnL >= 0 ? 'text-success' : 'text-danger';
  const optionClass = optionPnL >= 0 ? 'text-success' : 'text-danger';

  return (
    <div className="position-ledger-summary">
      <div className="row g-3">
        {/* Total P&L */}
        <div className="col-md-3">
          <div className="summary-card bg-dark text-white">
            <div className="summary-label">Total P&L</div>
            <div className={`summary-value ${pnlClass}`}>
              ${summary.total_pnl || '0.00'}
            </div>
          </div>
        </div>

        {/* Stock P&L */}
        <div className="col-md-3">
          <div className="summary-card">
            <div className="summary-label">Stock P&L</div>
            <div className={`summary-value ${stockClass}`}>
              ${summary.stock_pnl || '0.00'}
            </div>
            <div className="summary-detail">
              {summary.active_stocks || 0} active · {summary.closed_stocks || 0} closed
            </div>
          </div>
        </div>

        {/* Option P&L */}
        <div className="col-md-3">
          <div className="summary-card">
            <div className="summary-label">Option P&L</div>
            <div className={`summary-value ${optionClass}`}>
              ${summary.option_pnl || '0.00'}
            </div>
            <div className="summary-detail">
              {summary.active_options || 0} active · {summary.closed_options || 0} closed
            </div>
          </div>
        </div>

        {/* Position Count */}
        <div className="col-md-3">
          <div className="summary-card">
            <div className="summary-label">Total Positions</div>
            <div className="summary-value text-info">
              {summary.total_active || 0}
            </div>
            <div className="summary-detail">
              {summary.total_closed || 0} realized trades
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PositionLedgerSummary;